import services from "services";

import encodeQueryParams from "common/encode-query-params";

import END_POINT_PATH from "constants/end-point-path";

import ClientRequestDto from "dto/services/clients/client-request-dto";
import ClientResponseDto from "dto/services/clients/client-response-dto";
import LoginRequestDto from "dto/services/authenticate/login-request-dto";
import FaqCreateRequestDto from "dto/services/faq/faq-create-request-dto";
import ArticleRequestDto from "dto/services/articles/article-request-dto";
import FaqCreateResponseDto from "dto/services/faq/faq-create-response-dto";
import FaqListingRequestDto from "dto/services/faq/faq-listing-request-dto";
import LoginResponseDto from "dto/services/authenticate/login-response-dto";
import ArticleResponseDto from "dto/services/articles/article-response-dto";
import FaqUpdateResponseDto from "dto/services/faq/faq-update-response-dto";
import FaqListingResponseDto from "dto/services/faq/faq-listing-response-dto";
import PopupAdsRequestDto from "dto/services/popup-ads/popup-ads-request-dto";
import PopupAdsResponseDto from "dto/services/popup-ads/popup-ads-response-dto";
import EnquiryRequestDto from "dto/services/enquiry/enquiry-listing-request-dto";
import CareerCreateRequestDto from "dto/services/career/career-create-request-dto";
import EnquiryResponseDto from "dto/services/enquiry/enquiry-listing-response-dto";
import ClientCreateRequestDto from "dto/services/clients/client-create-request-dto";
import CareerListingRequestDto from "dto/services/career/career-listing-request-dto";
import CareerCreateResponseDto from "dto/services/career/career-create-response-dto";
import CareerUpdateResponseDto from "dto/services/career/career-update-response-dto";
import ClientCreateResponseDto from "dto/services/clients/client-create-response-dto";
import CareerListingResponseDto from "dto/services/career/career-listing-response-dto";
import ArticleCreateRequestDto from "dto/services/articles/article-create-request-dto";
import ArticleUpdateRequestDto from "dto/services/articles/article-update-request-dto";
import EnquiryUpdateResponseDto from "dto/services/enquiry/enquiry-update-response-dto";
import ClientsListingRequestDto from "dto/services/clients/clients-listing-request-dto";
import ArticleListingRequestDto from "dto/services/articles/article-listing-request-dto";
import ArticleCreateResponseDto from "dto/services/articles/article-create-response-dto";
import ArticleUpdateResponseDto from "dto/services/articles/article-update-response-dto";
import SolutionCreateRequestDto from "dto/services/solution/solution-create-request-dto";
import PartnersCreateRequestDto from "dto/services/partners/partners-create-request-dto";
import ClientsListingResponseDto from "dto/services/clients/clients-listing-response-dto";
import SolutionCreateResponseDto from "dto/services/solution/solution-create-response-dto";
import SolutionUpdateResponseDto from "dto/services/solution/solution-update-response-dto";
import ArticleListingResponseDto from "dto/services/articles/article-listing-response-dto";
import SolutionListingRequestDto from "dto/services/solution/solution-listing-request-dto";
import PopupAdsCreateRequestDto from "dto/services/popup-ads/popup-ads-create-request-dto";
import PartnersListingRequestDto from "dto/services/partners/partners-listing-request-dto";
import PartnersCreateResponseDto from "dto/services/partners/partners-create-response-dto";
import PartnersUpdateResponseDto from "dto/services/partners/partners-update-response-dto";
import ResourcesUpdateRequestDto from "dto/services/resources/resources-update-request-dto";
import SolutionListingResponseDto from "dto/services/solution/solution-listing-response-dto";
import PopupAdsUpdateResponseDto from "dto/services/popup-ads/popup-ads-update-response-dto";
import PopupAdsCreateResponseDto from "dto/services/popup-ads/popup-ads-create-response-dto";
import PopupAdsListingRequestDto from "dto/services/popup-ads/popup-ads-listing-request-dto";
import ForgotPasswordRequestDto from "dto/services/authenticate/forgot-password-request-dto";
import PartnersListingResponseDto from "dto/services/partners/partners-listing-response-dto";
import EBrochureCreateRequestDto from "dto/services/e-brochure/e-brochure-create-request-dto";
import ForgotPasswordResponseDto from "dto/services/authenticate/forgot-password-response-dto";
import PopupAdsListingResponseDto from "dto/services/popup-ads/popup-ads-listing-response-dto";
import EBrochureListingRequestDto from "dto/services/e-brochure/e-brochure-listing-request-dto";
import EBrochureCreateResponseDto from "dto/services/e-brochure/e-brochure-create-response-dto";
import EBrochureUpdateResponseDto from "dto/services/e-brochure/e-brochure-update-response-dto";
import OfficeLocationRequestDto from "dto/services/office-location/office-location-request-dto";
import JobApplicationResponseDto from "dto/services/job-application/job-application-response-dto";
import EBrochureListingResponseDto from "dto/services/e-brochure/e-brochure-listing-response-dto";
import ResourcesTemplateResponseDto from "dto/services/resources/resources-template-response-dto";
import OfficeLocationResponseDto from "dto/services/office-location/office-location-response-dto";
import JobApplicationRequestDto from "dto/services/job-application/job-application-listing-request-dto";
import ResourcesTemplateInfoRequestDto from "dto/services/resources/resources-template-info-request-dto";
import SolutionGroupListingRequestDto from "dto/services/solution-group/solution-group-list-request-dto";
import OfficeLocationListRequestDto from "dto/services/office-location/office-location-list-request-dto";
import SolutionGroupCreateRequestDto from "dto/services/solution-group/solution-group-create-request-dto";
import ResourcesTemplateInfoResponseDto from "dto/services/resources/resources-template-info-response-dto";
import SolutionGroupListingResponseDto from "dto/services/solution-group/solution-group-list-response-dto";
import OfficeLocationListResponseDto from "dto/services/office-location/office-location-list-response-dto";
import SolutionGroupUpdateResponseDto from "dto/services/solution-group/solution-group-update-response-dto";
import { FaqUpdatePayloadRequestDto, FaqUpdateIdRequestDto } from "dto/services/faq/faq-update-request-dto";
import SolutionGroupCreateResponseDto from "dto/services/solution-group/solution-group-create-response-dto";
import ArticleCategoryListRequestDto from "dto/services/article-category/article-category-list-request-dto";
import OfficeLocationCreateRequestDto from "dto/services/office-location/office-location-create-request-dto";
import RecipientEmailUpdateRequestDto from "dto/services/recipient-email/recipient-email-update-request-dto";
import OfficeLocationUpdateRequestDto from "dto/services/office-location/office-location-update-request-dto";
import ArticleCategoryListResponseDto from "dto/services/article-category/artilce-category-list-response-dto";
import RecipientEmailResponseDto from "dto/services/recipient-email/recipient-email-array-input-response-dto";
import OfficeLocationCreateResponseDto from "dto/services/office-location/office-location-create-response-dto";
import OfficeLocationUpdateResponseDto from "dto/services/office-location/office-location-update-response-dto";
import ResourcesActiveTemplateResponseDto from "dto/services/resources/resources-active-template-response-dto";
import JobApplicationUpdateResponseDto from "dto/services/job-application/job-application-update-response-dto";
import ArticleCategoryCreateRequestDto from "dto/services/article-category/article-category-create-request-dto";
import ClientPlatformListingAllResponseDto from "dto/services/clients/client-platform-listing-all-response-dto";
import CareerUpdateRequestDto, { CareerUpdateIdRequestDto } from "dto/services/career/career-update-request-dto";
import ArticleCategoryCreateResponseDto from "dto/services/article-category/article-category-create-reponse-dto";
import ArticleCategoryUpdateResponseDto from "dto/services/article-category/article-category-update-response-dto";
import ClientUpdateRequestDto, { ClientUpdateIdRequestDto } from "dto/services/clients/client-update-request-dto";
import EnquiryUpdateRequestDto, { EnquiryUpdateIdRequestDto } from "dto/services/enquiry/enquiry-update-request-dto";
import SolutionUpdateRequestDto, { SolutionUpdateIdRequestDto } from "dto/services/solution/solution-update-request-dto";
import PartnersUpdateRequestDto, { PartnersUpdateIdRequestDto } from "dto/services/partners/partners-update-request-dto";
import SolutionCategoriesCreateRequestDto from "dto/services/solution-categories/solution-categories-create-request-dto";
import ResourcesUpdateActiveTemplateRequestDto from "dto/services/resources/resources-update-active-template-request-dto";
import PopupAdsUpdateRequestDto, { PopupAdsUpdateIdRequestDto } from "dto/services/popup-ads/popup-ads-update-request-dto";
import SolutionCategoriesListingRequestDto from "dto/services/solution-categories/solution-categories-listing-request-dto";
import SolutionCategoriesCreateResponseDto from "dto/services/solution-categories/solution-categories-create-response-dto";
import SolutionCategoriesUpdateResponseDto from "dto/services/solution-categories/solution-categories-update-response-dto";
import ClientUpdateResponseDto, { ClientUpdateSortNumberResponseDto } from "dto/services/clients/client-update-response-dto";
import SolutionCategoriesListingResponseDto from "dto/services/solution-categories/solution-categories-listing-response-dto";
import EBrochureUpdateRequestDto, { EBrochureUpdateIdRequestDto } from "dto/services/e-brochure/e-brochure-update-request-dto";
import SolutionGroupUpdateRequestDto, { SolutionGroupUpdateIdRequestDto } from "dto/services/solution-group/solution-group-update-request-dto";
import JobApplicationUpdateRequestDto, { JobApplicationUpdateIdRequestDto } from "dto/services/job-application/job-application-update-request-dto";
import ArticleCategoryUpdateRequestDto, { ArticleCategoryUpdateIdRequestDto } from "dto/services/article-category/article-category-update-request-dto";
import SolutionCategoriesUpdateRequestDto, { SolutionCategoriesUpdateIdRequestDto } from "dto/services/solution-categories/solution-categories-update-request-dto";

const api = {
	get: {
		articles: {
			articles: (sort: string, params: ArticleListingRequestDto) => services.get<ArticleListingResponseDto>(END_POINT_PATH.ARTICLES.ARTICLES + `${sort}` + encodeQueryParams(params)),
			categoryTitle: (params: { size: number; page: number }) => services.get(END_POINT_PATH.ARTICLES.CATEGORY_TITLE + encodeQueryParams(params)),
			article: ({ id }: ArticleRequestDto) => services.get<ArticleResponseDto>(END_POINT_PATH.ARTICLES.ARTICLE + `${id}`),
		},
		faq: {
			faqs: (params: FaqListingRequestDto) => services.get<FaqListingResponseDto>(END_POINT_PATH.FAQ.FAQS + encodeQueryParams(params)),
		},
		enquiry: {
			enquiries: (params: EnquiryRequestDto) => services.get<EnquiryResponseDto>(END_POINT_PATH.ENQUIRY.ENQUIRIES + encodeQueryParams(params)),
		},
		career: {
			careers: (params: CareerListingRequestDto) => services.get<CareerListingResponseDto>(END_POINT_PATH.CAREER.CAREERS + encodeQueryParams(params)),
		},
		jobApplication: {
			jobs: (params: JobApplicationRequestDto) => services.get<JobApplicationResponseDto>(END_POINT_PATH.JOB.JOBS + encodeQueryParams(params)),
		},
		brochure: {
			solutionTitle: () => services.get(END_POINT_PATH.BROCHURE.SOLUTION_TITLE),
			services: (id: string, params: EBrochureListingRequestDto) => services.get(END_POINT_PATH.BROCHURE.SERVICES + `${id}` + encodeQueryParams(params)),
			allBrochures: (id: string, params: EBrochureListingRequestDto) => services.get<EBrochureListingResponseDto>(END_POINT_PATH.BROCHURE.ALL_BROCHURES + `${id}` + encodeQueryParams(params)),
			brochures: (type: string, params: EBrochureListingRequestDto) => services.get<EBrochureListingResponseDto>(END_POINT_PATH.BROCHURE.BROCHURES + `${type}` + encodeQueryParams(params)),
		},
		solution: {
			solutionTitle: () => services.get(END_POINT_PATH.SOLUTION.SOLUTION_TITLE),
			services: (id: string, params: SolutionListingRequestDto) => services.get(END_POINT_PATH.SOLUTION.SERVICES + `${id}` + encodeQueryParams(params)),
			allServices: (id: string, params: SolutionListingRequestDto) => services.get<SolutionListingResponseDto>(END_POINT_PATH.SOLUTION.ALL_SERVICES + `${id}` + encodeQueryParams(params)),
			servicesCard: (id: string, params: SolutionListingRequestDto) => services.get<SolutionListingResponseDto>(END_POINT_PATH.SOLUTION.SERVICES_CARD + `${id}` + encodeQueryParams(params)),
		},
		client: {
			client: ({ id }: ClientRequestDto) => services.get<ClientResponseDto>(END_POINT_PATH.CLIENT.CLIENT + `${id}`),
			clients: (params: ClientsListingRequestDto) => services.get<ClientsListingResponseDto>(END_POINT_PATH.CLIENT.CLIENTS + encodeQueryParams(params)),
			clientPlatform: () => services.get<ClientPlatformListingAllResponseDto>(END_POINT_PATH.CLIENT.CLIENT_PLATFORM),
		},
		resources: {
			templates: () => services.get<ResourcesTemplateResponseDto>(END_POINT_PATH.RESOURCES.TEMPLATES),
			activeTemplate: () => services.get<ResourcesActiveTemplateResponseDto>(END_POINT_PATH.RESOURCES.ACTIVE_TEMPLATE),
			templateInfo: (payload: ResourcesTemplateInfoRequestDto) => services.get<ResourcesTemplateInfoResponseDto>(END_POINT_PATH.RESOURCES.INFO + `${payload.template}`),
		},
		announcement: {
			announcements: (params: PopupAdsListingRequestDto) => services.get<PopupAdsListingResponseDto>(END_POINT_PATH.ANNOUNCEMENT.ANNOUNCEMENTS + encodeQueryParams(params)),
			announcement: ({ id }: PopupAdsRequestDto) => services.get<PopupAdsResponseDto>(END_POINT_PATH.ANNOUNCEMENT.ANNOUNCEMENT + `${id}`),
		},
		emails: {
			emails: (payload: ResourcesTemplateInfoRequestDto) => services.get<RecipientEmailResponseDto>(END_POINT_PATH.EMAILS.EMAILS + `${payload.template}`),
		},
		partners: {
			partners: (params: PartnersListingRequestDto) => services.get<PartnersListingResponseDto>(END_POINT_PATH.PARTNERS.PARTNERS + encodeQueryParams(params)),
		},
		solution_group: {
			list: (params: SolutionGroupListingRequestDto) => services.get<SolutionGroupListingResponseDto>(END_POINT_PATH.SOLUTION_GROUP.LIST + encodeQueryParams(params)),
		},
		solution_categories: {
			categories: (params: SolutionCategoriesListingRequestDto) => services.get<SolutionCategoriesListingResponseDto>(END_POINT_PATH.SOLUTION_CATEGORIES.CATEGORIES + encodeQueryParams(params)),
		},
		location: {
			locations: (params: OfficeLocationListRequestDto) => services.get<OfficeLocationListResponseDto>(END_POINT_PATH.LOCATION.LOCATIONS + encodeQueryParams(params)),
			location: ({ id }: OfficeLocationRequestDto) => services.get<OfficeLocationResponseDto>(END_POINT_PATH.LOCATION.LOCATION + `${id}`),
		},
		article_category: {
			category: (params: ArticleCategoryListRequestDto) => services.get<ArticleCategoryListResponseDto>(END_POINT_PATH.ARTICLE_CATEGORY.CATEGORY + encodeQueryParams(params)),
		},
	},
	post: {
		authenticate: {
			login: (payload: LoginRequestDto) => services.post<LoginResponseDto>(END_POINT_PATH.AUTHENTICATE.LOGIN, payload),
			forgotPassword: (payload: ForgotPasswordRequestDto) => services.post<ForgotPasswordResponseDto>(END_POINT_PATH.AUTHENTICATE.FORGOT_PASSWORD, payload),
		},
		articles: {
			create: (payload: ArticleCreateRequestDto) => services.post<ArticleCreateResponseDto>(END_POINT_PATH.ARTICLES.CREATE, payload),
		},
		faq: {
			create: (payload: FaqCreateRequestDto) => services.post<FaqCreateResponseDto>(END_POINT_PATH.FAQ.CREATE, payload),
		},
		career: {
			create: (payload: CareerCreateRequestDto) => services.post<CareerCreateResponseDto>(END_POINT_PATH.CAREER.CREATE, payload),
		},
		brochure: {
			create: (payload: EBrochureCreateRequestDto) => services.post<EBrochureCreateResponseDto>(END_POINT_PATH.BROCHURE.CREATE, payload),
		},
		solution: {
			create: (payload: SolutionCreateRequestDto) => services.post<SolutionCreateResponseDto>(END_POINT_PATH.SOLUTION.CREATE, payload),
		},
		client: {
			create: (payload: ClientCreateRequestDto) => services.post<ClientCreateResponseDto>(END_POINT_PATH.CLIENT.CREATE, payload),
		},
		resources: {
			update: (payload: ResourcesUpdateRequestDto) => services.post(END_POINT_PATH.RESOURCES.UPDATE, payload),
		},
		announcement: {
			create: (payload: PopupAdsCreateRequestDto) => services.post<PopupAdsCreateResponseDto>(END_POINT_PATH.ANNOUNCEMENT.CREATE, payload),
		},
		partners: {
			create: (payload: PartnersCreateRequestDto) => services.post<PartnersCreateResponseDto>(END_POINT_PATH.PARTNERS.CREATE, payload),
		},
		emails: {
			update: (payload: RecipientEmailUpdateRequestDto) => services.post(END_POINT_PATH.EMAILS.UPDATE, payload),
		},
		solution_group: {
			create: (payload: SolutionGroupCreateRequestDto) => services.post<SolutionGroupCreateResponseDto>(END_POINT_PATH.SOLUTION_GROUP.CREATE, payload),
		},
		solution_categories: {
			create: (payload: SolutionCategoriesCreateRequestDto) => services.post<SolutionCategoriesCreateResponseDto>(END_POINT_PATH.SOLUTION_CATEGORIES.CREATE, payload),
		},
		location: {
			create: (payload: OfficeLocationCreateRequestDto) => services.post<OfficeLocationCreateResponseDto>(END_POINT_PATH.LOCATION.CREATE, payload),
		},
		article_category: {
			create: (payload: ArticleCategoryCreateRequestDto) => services.post<ArticleCategoryCreateResponseDto>(END_POINT_PATH.ARTICLE_CATEGORY.CREATE, payload),
		},
	},
	patch: {},
	put: {
		articles: {
			update: (payload: ArticleUpdateRequestDto) => services.put<ArticleUpdateResponseDto>(END_POINT_PATH.ARTICLES.UPDATE + payload.id, payload),
			delete: ({ id }: ArticleRequestDto) => services.put<ArticleResponseDto>(END_POINT_PATH.ARTICLES.DELETE + `${id}`),
		},
		jobApplication: {
			update: ({ id }: JobApplicationUpdateIdRequestDto, payload: JobApplicationUpdateRequestDto) => services.put<JobApplicationUpdateResponseDto>(END_POINT_PATH.JOB.UPDATE + `${id}`, payload),
		},
		faq: {
			update: ({ id }: FaqUpdateIdRequestDto, payload: FaqUpdatePayloadRequestDto) => services.put<FaqUpdateResponseDto>(END_POINT_PATH.FAQ.UPDATE + `${id}`, payload),
		},
		enquiry: {
			update: ({ id }: EnquiryUpdateIdRequestDto, payload: EnquiryUpdateRequestDto) => services.put<EnquiryUpdateResponseDto>(END_POINT_PATH.ENQUIRY.UPDATE + `${id}`, payload),
		},
		career: {
			update: ({ id }: CareerUpdateIdRequestDto, payload: CareerUpdateRequestDto) => services.put<CareerUpdateResponseDto>(END_POINT_PATH.CAREER.UPDATE + `${id}`, payload),
			delete: ({ id }: CareerUpdateIdRequestDto) => services.put<CareerUpdateResponseDto>(END_POINT_PATH.CAREER.DELETE + `${id}`),
		},
		brochure: {
			update: ({ id }: EBrochureUpdateIdRequestDto, payload: EBrochureUpdateRequestDto) => services.put<EBrochureUpdateResponseDto>(END_POINT_PATH.BROCHURE.UPDATE + `${id}`, payload),
			delete: ({ id }: EBrochureUpdateIdRequestDto) => services.put<EBrochureUpdateResponseDto>(END_POINT_PATH.BROCHURE.DELETE + `${id}`),
		},
		solution: {
			update: ({ id }: SolutionUpdateIdRequestDto, payload: SolutionUpdateRequestDto) => services.put<SolutionUpdateResponseDto>(END_POINT_PATH.SOLUTION.UPDATE + `${id}`, payload),
		},
		client: {
			update: ({ id }: ClientUpdateIdRequestDto, payload: ClientUpdateRequestDto) => services.put<ClientUpdateResponseDto>(END_POINT_PATH.CLIENT.UPDATE + `${id}`, payload),
			update_sortNumber: ({ id }: ClientUpdateIdRequestDto, sortNumber: number) => services.put<ClientUpdateSortNumberResponseDto>(END_POINT_PATH.CLIENT.UPDATE_SORT_NUMBER + `${id}/${sortNumber}`),
		},
		resources: {
			updateActiveTemplate: ({ template }: ResourcesUpdateActiveTemplateRequestDto) => services.put(END_POINT_PATH.RESOURCES.UPDATE_ACTIVE_TEMPLATE + `${template}`),
		},
		announcement: {
			update: ({ id }: PopupAdsUpdateIdRequestDto, payload: PopupAdsUpdateRequestDto) => services.put<PopupAdsUpdateResponseDto>(END_POINT_PATH.ANNOUNCEMENT.UPDATE + `${id}`, payload),
		},
		partners: {
			update: ({ id }: PartnersUpdateIdRequestDto, payload: PartnersUpdateRequestDto) => services.put<PartnersUpdateResponseDto>(END_POINT_PATH.PARTNERS.UPDATE + `${id}`, payload),
		},
		solution_group: {
			update: ({ id }: SolutionGroupUpdateIdRequestDto, payload: SolutionGroupUpdateRequestDto) => services.put<SolutionGroupUpdateResponseDto>(END_POINT_PATH.SOLUTION_GROUP.UPDATE + `${id}`, payload),
		},
		solution_categories: {
			update: ({ id }: SolutionCategoriesUpdateIdRequestDto, payload: SolutionCategoriesUpdateRequestDto) => services.put<SolutionCategoriesUpdateResponseDto>(END_POINT_PATH.SOLUTION_CATEGORIES.UPDATE + `${id}`, payload),
		},
		location: {
			update: (payload: OfficeLocationUpdateRequestDto) => services.put<OfficeLocationUpdateResponseDto>(END_POINT_PATH.LOCATION.UPDATE + payload.id, payload),
		},
		article_category: {
			update: ({ id }: ArticleCategoryUpdateIdRequestDto, payload: ArticleCategoryUpdateRequestDto) => services.put<ArticleCategoryUpdateResponseDto>(END_POINT_PATH.ARTICLE_CATEGORY.UPDATE + `${id}`, payload),
		},
	},
};

export default api;
